export DsfRow12 from "./row_1_2.vue";
export DsfRow from "./row.vue";
export DsfFlexColumn from "./column.vue";
export DsfRowHalf from "./rowHalf.js";
export DsfCol from "./col.vue";
export DsfRow13 from "./row_1_3.vue";
export DsfTable from "./table.vue";
export DsfTableRow from "./tableRow.vue";
export DsfTableCell from "./tableCell.vue";
export DsfViewPart from "./viewPart.vue";
export DsfMultiRouteView from './multiRouteView.js'
// export DsfDragGrid from './dragGrid.vue'

export const DsfDragGrid=dsf.defineLazyComponent('DsfDragGrid',()=>require("./dragGrid.vue"))
export const DsfFastFormLayout=dsf.defineLazyComponent('DsfFastFormLayout',()=>require("./fastFormLayout.vue"))
export const DsfGridLayout=dsf.defineLazyComponent('DsfGridLayout',()=>require("./grid.vue"))
export const DsfFlexibleBox=dsf.defineLazyComponent('DsfFlexibleBox',()=>require("./flexibleBox.vue"))
export const DsfVirtualScroll=dsf.defineLazyComponent('DsfVirtualScroll',()=>require("./virtualScroll.vue"))


export const DsfLazyBox=dsf.defineAsyncComponent('DsfLazyBox',()=>import(/*webpackChunkName:"platform_pc_layout"*/"./lazybox.vue"))
export const DsfCollapse=dsf.defineAsyncComponent('DsfCollapse',()=>import(/*webpackChunkName:"platform_pc_layout"*/"./collapse.vue"))
export const DsfSection=dsf.defineAsyncComponent('DsfSection',()=>import(/*webpackChunkName:"platform_pc_layout"*/"./section.vue"))
export const DsfIframe=dsf.defineAsyncComponent('DsfIframe',()=>import(/*webpackChunkName:"platform_pc_layout"*/"./iframe.vue"))